export function getSearchPathFromQuery(query) {
  return [
    '/search',
    query ? `/${encodeURIComponent(query)}` : ''
  ].join('');
}
